module.exports = __webpack_public_path__ + "static/media/slideBg1.d155dc97.jpg";